import { Loading } from '@carbon/react';
import classNames from 'classnames';
import type { PartyStatus } from 'components/status-tag';
import { STATUS_CELL_CONFIG } from './party-status';
import style from './structuring-module.module.scss';

interface StatusNodeLabelProps {
  text: string;
  status: PartyStatus;
  removed?: boolean;
  // What runs, describing the spinner shown in place of the status icon.
  running?: string;
}

/**
 * A navigation-tree label: status icon (or the running spinner) and the text,
 * which truncates with an ellipsis and shows in full on hover.
 *
 * @param {StatusNodeLabelProps} props - The label text, the party status, the removed flag and what runs.
 * @return {JSX.Element} The tree-node label.
 */
export function StatusNodeLabel({
  text,
  status,
  removed = false,
  running,
}: StatusNodeLabelProps) {
  const cfg = STATUS_CELL_CONFIG[status];
  const Icon = cfg.icon;
  return (
    <span className={style.partyNodeLabel}>
      {running ? (
        <Loading
          withOverlay={false}
          small
          className={classNames(style.partyNodeIcon, style.partyNodeSpinner)}
          description={running}
        />
      ) : (
        <Icon
          className={classNames(style.partyNodeIcon, style[cfg.className])}
          aria-label={cfg.label}
        />
      )}
      <span
        className={classNames(style.treeNodeText, {
          [style.partyNodeRemoved]: removed,
        })}
        title={text}
      >
        {text}
      </span>
    </span>
  );
}
